import React from 'react';

import styles from './progressBarStyles';

const ProgressBar = ({ progress }) => {
  const barLength = { width: `${progress}%` };
  return (
    <div className={styles.progressbarBackgroundSmall}>
      <div className={styles.progressbarContainer} role="progressbar" style={barLength} />
    </div>
  );
};

export default ProgressBar;
